import { render } from "./AddOptions.vue?vue&type=template&id=9512e7dc"
import script from "./AddOptions.vue?vue&type=script&lang=js"
export * from "./AddOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__